import { getAllEvents } from './Actions/getAllEvents';
import { get } from './Actions/get';
import { getRound } from './Actions/getRound';
import { getRegistrationSummary } from './Actions/getRegistrationSummary';
import { register } from './Actions/register';
import { withdraw } from './Actions/withdraw';
import { setMessage } from './Actions/setMessage';
import { getAllFutureEvents } from './Actions/getAllFutureEvents';
import { TActionsWithoutState } from '../../Interfaces/TActionsWithoutState';
import { getAllFutureClubEvents } from './Actions/getAllFutureClubEvents';
import { getAllClubEvents } from './Actions/getAllClubEvents';

const actions = {
  get,
  getAllClubEvents,
  getAllEvents,
  getAllFutureClubEvents,
  getAllFutureEvents,
  getRegistrationSummary,
  getRound,
  register,
  setMessage,
  withdraw
};

export type IEventsActions = TActionsWithoutState<typeof actions>;

export default actions;
